var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Type=Logo Circle, Component=Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_37_996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8987 12H13.7205C11.137 12 9.33325 13.7803 9.33325 16.3316V23.6684C9.33325 26.2197 11.137 28 13.7205 28H19.8987C22.4822 28 24.2859 26.2197 24.2859 23.6684V16.3316C24.2859 13.7803 22.4822 12 19.8987 12ZM29.953 14.6058C29.506 14.3243 28.9567 14.2993 28.4884 14.5376L26.9076 15.3357C26.3231 15.6302 25.9604 16.2258 25.9604 16.8886V23.111C25.9604 23.7726 26.3231 24.3682 26.9076 24.665L28.4874 25.462C28.7018 25.5714 28.9311 25.6255 29.1604 25.6255C29.4356 25.6255 29.7087 25.5475 29.953 25.3948C30.3999 25.1144 30.6666 24.6281 30.6666 24.0943V15.9064C30.6666 15.3736 30.3999 14.8863 29.953 14.6058ZM19.9195 19.7427C19.7535 19.2867 19.169 18.9492 17.9999 18.2742C16.8308 17.5993 16.2463 17.2618 15.7684 17.346C15.4597 17.4005 15.18 17.5619 14.9785 17.8021C14.6666 18.1738 14.6666 18.8488 14.6666 20.1987C14.6666 21.5487 14.6666 22.2236 14.9785 22.5954C15.18 22.8355 15.4597 22.997 15.7684 23.0514C16.2463 23.1357 16.8308 22.7982 17.9999 22.1232C19.169 21.4483 19.7535 21.1108 19.9195 20.6548C20.0267 20.3602 20.0267 20.0373 19.9195 19.7427Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_996",
    x1: 40,
    y1: 40,
    x2: -7.59641,
    y2: 26.1999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4D67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8395"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0331ed3c7b6173c30f92ec985317ed2c.svg";
export { ForwardRef as ReactComponent };